import { render } from "./AuthoringFilters.vue?vue&type=template&id=54583c0a&scoped=true"
import script from "./AuthoringFilters.vue?vue&type=script&lang=js"
export * from "./AuthoringFilters.vue?vue&type=script&lang=js"

import "./AuthoringFilters.vue?vue&type=style&index=0&id=54583c0a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54583c0a"]])

export default __exports__